import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

import messages from "../../../assets/locale/messages";
import Modal from "../../../components/Modal";
import { DeleteModalIcon } from "../../../utils/Icons";
import { deleteRoleRequest } from "../../../store/Roles/actions";

const DeleteRole = ({ open, closeModal, roleInfo }) => {
  const lang = useSelector((state) => state.locale.lang);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { roles, shared } = messages[lang];

  const handleConfirmDelete = () => {
    dispatch(
      deleteRoleRequest({
        data: {
          Id: roleInfo.id
        },
        src: roleInfo.src,
        params: roleInfo.params,
        navigate
      })
    );
    closeModal();
  };
  const deleteRoleContent = () => {
    return (
      <div className="delete-category-container container d-flex flex-column justify-content-center align-items-center">
        <DeleteModalIcon />
        <div className="delete-category-content mt-2 d-flex flex-column justify-content-center align-items-center text-center">
          <Typography className="fsize-20 fweight-700">
            {`${roles.deleteRole.content} "${roleInfo.name}" Role !`}
          </Typography>
          <Typography className="text-secondary fsize-14 mt-2 fweight-600">
            {roles.deleteRole.confirmationContent}
          </Typography>
          <Typography className="text-secondary fsize-14 mt-2 fweight-600">
            {roles.deleteRole.subConfirmationContent}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={open}
      handleConfirm={() => {
        handleConfirmDelete();
      }}
      handleClose={closeModal}
      isContentText={false}
      content={deleteRoleContent()}
      hasActions={true}
      confirmBtnTxt={shared.delete}
      cancelBtnTxt={shared.cancel}
      handleCancel={closeModal}
      showCloseIcon
      title
      confirmBtnClass="danger-btn border-radius-12 ps-5 pe-5"
      cancelBtnClass="text-secondary border-radius-12 ps-5 pe-5"
      maxWidth={"xs"}
    />
  );
};

export default DeleteRole;

DeleteRole.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  roleInfo: PropTypes.object.isRequired
};
